import { render, staticRenderFns } from "./ArmamentoDotacionPage.vue?vue&type=template&id=fa5e0892"
import script from "./ArmamentoDotacionPage.js?vue&type=script&lang=js&external"
export * from "./ArmamentoDotacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports